import React, {Component} from 'react';
import {connect} from 'react-redux'
import Form from '../forms/Form'
import { virszemesSlodzuButiskumiActions } from '../../actions/slodzuButiskumsActions';
import { getDefaultTypeaheadOptionsFromKodifArray } from '../forms/FormHelpers';
import { getBooleanFormatter, getBooleanSelectFilterCfg } from '../grid/ColumnHelpers';

const getFormFieldCfgs = ({kodif}) => {
  return [{
        name: 'udens_objekts_id',
        label: 'Ūdens objekts',
        type: 'autocomplete',
        required: true,
        autocompleteCfg: {
            remoteSearchViewName: 'udens_objekts_search',
            labelFieldName: 'uo_nosaukums'
        },
        renderer: (val, row) => (
            <span>{ row.uo_nosaukums }</span>
        )
    }, {
        name: 'gads',
        label: 'Slodžu izvērtējuma gads',
        type: 'number',
        renderClassName: 'bold',
        required: true
    }, {
        name: 'periods',
        label: 'Periods',
        renderClassName: "bold",
        required: true,
        type: 'autocomplete',
        autocompleteCfg: {
            options: getDefaultTypeaheadOptionsFromKodifArray(kodif, 'UO_PERIODS')
        }
    }, {
        name: 'punktveida',
        label: 'Punktveida slodze',
        type: 'checkbox',
        formatter: getBooleanFormatter(),
        filterCfg: getBooleanSelectFilterCfg()
    }, {
        name: 'izkliedeta',
        label: 'Izkliedētā slodze',
        type: 'checkbox',
        formatter: getBooleanFormatter(),
        filterCfg: getBooleanSelectFilterCfg()
    }, {
        name: 'hidro',
        label: 'Hidromorfoloģiskie pārveidojumi',
        type: 'checkbox',
        formatter: getBooleanFormatter(),
        filterCfg: getBooleanSelectFilterCfg()
    }, {
        name: 'citas',
        label: 'Citas slodzes',
        type: 'checkbox',
        formatter: getBooleanFormatter(),
        filterCfg: getBooleanSelectFilterCfg()
    }
  ]
};

class VirszemesSlodzuButiskums extends Component {

  render() {
    const {virszemesSlodzuButiskums, kodif, saveAct, stopEditAct, startEditAct, deleteAct} = this.props

    if(!this.formFieldCfgs){
      this.formFieldCfgs = getFormFieldCfgs({
        kodif: kodif
      })
    }

    const {editable, submiting, selectedItem} = virszemesSlodzuButiskums

    return (
      <div className="form-wrapper-pane">
        <Form
          editable={editable}
          submiting={submiting}
          dataObj={selectedItem}
          formFieldCfgs={this.formFieldCfgs}
          onSubmit={saveAct}
          onReset={stopEditAct}
          onStartEdit={startEditAct}
          onDelete={deleteAct}
          tiesibasLabot={'BAIS_VU_PAMAT_LABOT'}
        />
      </div>
    )
  }
}

const mapStateToProps = ({virszemesSlodzuButiskums, kodif}) => ({virszemesSlodzuButiskums, kodif})

export default connect(mapStateToProps, {...virszemesSlodzuButiskumiActions})(VirszemesSlodzuButiskums)
